
export interface IWobAdminChangedConstParam {
  wobType: string
  actionType: string
  aloDbClassName: string
  entityClassName: string
  oldAloDbItem : any
  newAloDbItem : any
  wobDat: string | null
}

export class WobAdminChanged<T> {
  public wobType: string
  public actionType: string
  public aloDbClassName: string
  public entityClassName: string
  public oldAloDbItem : T
  public newAloDbItem : T
  public wobDat: Date | null

  constructor({ wobType, actionType, aloDbClassName, entityClassName,oldAloDbItem,newAloDbItem,wobDat }: IWobAdminChangedConstParam,factory:(obj:any) => T) {    
    this.wobType = wobType
    this.actionType = actionType
    this.aloDbClassName = aloDbClassName
    this.entityClassName = entityClassName
    this.oldAloDbItem = factory(oldAloDbItem)
    this.newAloDbItem = factory(newAloDbItem)
    this.wobDat = wobDat ? new Date(wobDat) : null
  }

}
